<script setup lang="ts">
  import MaintenanceBanner from "@/components/shared/maintenance-banner/MaintenanceBanner.vue"
  import { usePageLevelMaintenance } from "@/components/shared/maintenance-banner/usePageLevelMaintenance"

  const { isUnderMaintenance } = usePageLevelMaintenance()
</script>

<template>
  <main>
    <div v-if="isUnderMaintenance" class="container p-6 pb-3">
      <MaintenanceBanner />
    </div>
    <slot />
  </main>
</template>
